import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {Router} from "@angular/router";

@Component({
  selector: 'app-sem-proposta',
  templateUrl: './sem-proposta.component.html',
  styleUrls: ['./sem-proposta.component.scss']
})
export class SemPropostaComponent {
  @Input() componente;
  @Output() atualizarPropostas = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    public route: Router,
    private bottomSheet: MatBottomSheet) { }

  mostrarDetalhes(): void {
    this.route.navigate(['proposta/criar']);
  }

  irPara(): void {
    this.route.navigate(['envio-cnds'])
  }
}
